export class MarketplaceTokenRequest {
  token: string;
  vendor: string;
}
